// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__1rnmb","title":"Login_title__qRHkz"};